import styled from 'styled-components';

import colors from 'themes/Main';

const { white, gray04, gray02, blue } = colors;

export const Container = styled.div`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
`;

export const Modal = styled.div`
  position: relative;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  width: 600px;
  padding: 32px 32px 64px;
  box-shadow: 0px 7px 8px rgba(0, 0, 0, 0.2), 0px 5px 22px rgba(0, 0, 0, 0.12),
    0px 12px 17px rgba(0, 0, 0, 0.14);
  background-color: ${white};
  border-radius: 10px;
`;

export const CloseModal = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  top: 8px;
  right: 8px;
  border: 0;
  outline: 0;
  transition: opacity 0.2s ease-in;
  padding: 4px;
  background: transparent;
  color: ${gray04};
  font-weight: 800;
  font-size: 24px;

  &:hover {
    opacity: 0.7;
    color: ${gray02};
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 64px;
`;

export const ModalCard = styled.div`
  cursor: pointer;
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 3px;
  border: 1px solid ${gray04};
  background-color: transparent;
  transition: all 0.25s ease-in;

  &:hover {
    background-color: ${blue};
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12),
      0px 2px 4px rgba(0, 0, 0, 0.14);
    border: 1px solid ${blue};

    svg {
      margin-bottom: 16px;

      path {
        fill: ${white};
      }
    }

    p {
      visibility: visible;
      color: ${white};
    }
  }

  svg {
    margin-bottom: -20px;
    transition: all 0.25s ease-in;

    path {
      fill: ${gray04};
    }
  }

  p {
    cursor: context-menu;
    visibility: hidden;
    font-size: 16px;
    text-transform: uppercase;
    color: ${white};
    text-align: center;
    font-weight: 700;
    transition: visibility 0.25s ease-in;
  }
`;
